import instance from '@/http';
export default {
	getInvoices(data) {
		return instance().post(`/invoice`, { limit: 999999, ...data }).then(resp => resp).catch(error => error);
	},
	getInvoice(data) {
		return instance().post(`/invoice/${ data.id }`, data.data).then(resp => resp).catch(error => error);
	},
	setPayment(data) {
		return instance().post('/invoice/setPayments', data).then(resp => resp).catch(error => error);
	},
	setInvoice(data) {
		return instance().post(`/invoice/update/${ data.id }`, data.data).then(resp => resp).catch(error => error);
	},
	deletedInvoice(data) {
		return instance().post(`/invoice/delete/${ data.id }`, { invoice_id: data.id }).then(resp => resp).catch(error => error);
	},
	sendInvoice(data) {
		return instance().post('/invoice/sendInvoice', data).then(resp => resp).catch(error => error);
	},
	getDataPaid(data) {
		return instance().get(`/payments/new/${ data }`).then(resp => resp);
	},
	paidInvoice(data) {
		return instance().post(`payments/${ data.invoice_id }`, data).then(resp => resp);
	}
};
